"use client";

import { Box, Link, styled } from "@mui/material";

interface BackButtonProps {
  title?: string;
  onClick: () => void;
}

const BackArrow = styled("img")({
  width: "12px",
  marginRight: "var(--space-2)",
});

// Cast back to `typeof Link` so the polymorphic `component` prop (lost when
// wrapping in styled()) is available on <BackLink component="button" …>.
const BackLink = styled(Link)({
  display: "flex",
  marginBottom: "var(--space-10)",
  font: "var(--text-body3)",
  alignItems: "center",
  cursor: "pointer",
  color: "#000000",
  textDecoration: "underline",
  textUnderlineOffset: "4px",
  "&:hover": {
    textDecoration: "none",
  },
}) as typeof Link;

export default function BackButton({ title, onClick }: BackButtonProps) {
  return (
    <BackLink
      id="backButton"
      component="button"
      variant="body1"
      underline="hover"
      onClick={onClick}
    >
      <Box display="flex" alignItems="center">
        <BackArrow src="/img/arrow-left-solid-2x.png" alt="" aria-hidden="true" />
        {title || "Back"}
      </Box>
    </BackLink>
  );
}
